import { CreateDiscussStoryMeta, CreateDiscussStoryPayload } from 'types/store/CreateDiscussStory';
import { createAsyncReducer } from 'utils/Redux';

import { createDiscussStoryActions } from '../actions';

export default createAsyncReducer<CreateDiscussStoryMeta, CreateDiscussStoryPayload>(createDiscussStoryActions);
